export default __webpack_public_path__ + "static/media/imagen_ video.c1224e77.jpg";